import { createAuthClient } from 'better-auth/react';
import {
  convexClient,
  crossDomainClient,
} from '@convex-dev/better-auth/client/plugins';

// Better Auth react client for PLAYER accounts. It talks to the Better Auth
// HTTP routes hosted inside Convex on the *.convex.site domain
// (VITE_CONVEX_SITE_URL). crossDomainClient is required because the player app
// (mgtrl.co) is a different origin from the auth routes; convexClient wires the
// session token into the ConvexReactClient. See docs/player-accounts.md.
export const authClient = createAuthClient({
  baseURL: import.meta.env.VITE_CONVEX_SITE_URL as string | undefined,
  plugins: [crossDomainClient(), convexClient()],
});
